import React, { useEffect, useState } from 'react';
import {
    Box, TextField, Button, Typography, Stack
} from '@mui/material';
import axios from 'axios';

const BuildingDetailsWallsAddDoor = ({ buildingId, wall, door, onSuccess, onError, onClose }) => {
    const [formData, setFormData] = useState({
        name: '',
        area: '',
        u_value: ''
    });

    const isEdit = Boolean(door?.id);

    useEffect(() => {
        if (isEdit) {
            axios.get(`/buildings/${buildingId}/walls/${wall.id}/doors/${door.id}/`)
                .then(res => {
                    const { name, area, u_value } = res.data;
                    setFormData({ name, area, u_value });
                })
                .catch(() => {
                    onError();
                });
        } else {
            setFormData({ name: '', area: '', u_value: '' });
        }
    }, [buildingId, wall.id, door]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            name: formData.name,
            area: parseFloat(formData.area),
            u_value: parseFloat(formData.u_value),
            wall: wall.id
        };

        const request = isEdit
            ? axios.put(`/buildings/${buildingId}/walls/${wall.id}/doors/${door.id}/`, payload)
            : axios.post(`/buildings/${buildingId}/walls/${wall.id}/doors/`, payload);

        request
            .then(() => onSuccess())
            .catch(() => onError());
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ p: 3, width: 400 }}>
            <Typography variant="h6" gutterBottom>
                {isEdit ? `Edit Door "${door.name}"` : `Add Door to ${wall.name}`}
            </Typography>
            <Stack spacing={2}>
                <TextField
                    label="Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    fullWidth
                />
                <TextField
                    label="Area"
                    name="area"
                    type="number"
                    inputProps={{ min: 0 }}
                    value={formData.area}
                    onChange={handleChange}
                    required
                    fullWidth
                />
                <TextField
                    label="U-Value"
                    name="u_value"
                    type="number"
                    inputProps={{ min: 0 }}
                    value={formData.u_value}
                    onChange={handleChange}
                    required
                    fullWidth
                />
                <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <Button variant="outlined" color="secondary" onClick={onClose}>Cancel</Button>
                    <Button variant="contained" type="submit">
                        {isEdit ? 'Update' : 'Add'}
                    </Button>
                </Stack>
            </Stack>
        </Box>
    );
};

export default BuildingDetailsWallsAddDoor;
